import groq from 'groq';
import { ImageComponentFragment } from './image';
import { createGrid } from '../resolvers/utils';

// Modal layout's grid items should include allowed types
// specified in `sanity-block-web/studio/schemas/components/modal.ts`.
// Resolve references at all nesting levels for any components that contain them.
export const ModalLayoutFragment = groq`
  defined(modal) => {
    "modal": modal->{
      ...,
      ${createGrid(ImageComponentFragment)}
    }
  }
`;
